module.exports = __webpack_public_path__ + "static/3dmodel05-89eb629d3725c786d156852183b2c36a.jpg";